"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Stylesheet_1 = require("./Stylesheet");
var styleToClassName_1 = require("./styleToClassName");
/**
 * Registers a font face.
 * @public
 */
function fontFace(font) {
    Stylesheet_1.Stylesheet.getInstance().insertRule("@font-face{" + styleToClassName_1.serializeRuleEntries(font) + "}");
}
exports.fontFace = fontFace;
//# sourceMappingURL=fontFace.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uifabric/merge-styles/lib/fontFace.js
// module id = ../node_modules/@uifabric/merge-styles/lib/fontFace.js
// module chunks = 1